(() => {
  const root = document.getElementById('cb-personalized-customizer');
  if (!root) return;

  const photoCount = Number(root.dataset.photoCount || 1);
  const variantId = root.dataset.variant || '';
  const addUrl = root.dataset.addUrl || '/cart/add.js';
  const cartJsonUrl = root.dataset.cartJsonUrl || '/cart.js';
  const form = root.querySelector('[data-cb-form]');
  const fileInput = root.querySelector('[data-cb-file]');
  const uploadTitle = root.querySelector('[data-cb-upload-title]');
  const uploadCount = root.querySelector('[data-cb-upload-count]');
  const messageInput = root.querySelector('[data-cb-message]');
  const emailInput = root.querySelector('[data-cb-email]');
  const counter = root.querySelector('[data-cb-counter]');
  const previewMessage = root.querySelector('[data-cb-preview-message]');
  const consentButton = root.querySelector('[data-cb-consent]');
  const saveButton = root.querySelector('[data-cb-save]');
  const errorBox = root.querySelector('[data-cb-error]');
  const successBox = root.querySelector('[data-cb-success]');
  const successText = successBox?.querySelector('span');
  const slots = [...root.querySelectorAll('[data-cb-slot]')];

  if (!form || !fileInput || !messageInput || !emailInput || !consentButton || !saveButton) return;

  let photos = [];
  let busy = false;
  let consent = false;
  let projectId = newProjectId();

  function newProjectId() {
    if (crypto.randomUUID) return crypto.randomUUID();
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }

  function resetSavedState() {
    projectId = newProjectId();
    successBox.hidden = true;
    saveButton.hidden = false;
  }

  function showError(message) {
    errorBox.textContent = message;
    errorBox.hidden = !message;
  }

  function setBusy(nextBusy) {
    busy = nextBusy;
    fileInput.disabled = nextBusy;
    saveButton.disabled = nextBusy;
    consentButton.disabled = nextBusy;
    if (nextBusy) {
      uploadTitle.textContent = 'Préparation en cours…';
      saveButton.textContent = 'Enregistrement en cours…';
    } else {
      uploadTitle.textContent = photoCount > 1 ? 'Importer mes photos' : 'Importer ma photo';
      saveButton.innerHTML = 'Ajouter au panier avec mes photos <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 7h10v10"></path><path d="M7 17 17 7"></path></svg>';
    }
  }

  function updateCount() {
    uploadCount.textContent = `${photos.length}/${photoCount} ajoutée${photos.length > 1 ? 's' : ''} · JPG, PNG ou WebP · 10 Mo maximum par photo`;
  }

  function emptySlot(slot, index) {
    slot.replaceChildren();
    const holder = document.createElement('div');
    holder.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect><circle cx="9" cy="9" r="2"></circle><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path></svg>';
    holder.append(document.createTextNode(`Photo ${index + 1}`));
    slot.append(holder);
  }

  function renderPhotos() {
    slots.forEach((slot, index) => {
      const photo = photos[index];
      if (!photo) {
        emptySlot(slot, index);
        return;
      }
      slot.replaceChildren();
      const image = document.createElement('img');
      image.src = photo.url;
      image.alt = `Votre photo ${index + 1}`;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'remove-photo';
      remove.setAttribute('aria-label', `Supprimer la photo ${index + 1}`);
      remove.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>';
      remove.addEventListener('click', () => {
        if (busy) return;
        URL.revokeObjectURL(photo.url);
        photos.splice(index, 1);
        resetSavedState();
        renderPhotos();
      });
      slot.append(image, remove);
    });
    updateCount();
  }

  async function readPhoto(file) {
    if (typeof createImageBitmap === 'function') {
      try {
        return await createImageBitmap(file);
      } catch (_) {}
    }
    const url = URL.createObjectURL(file);
    try {
      const image = new Image();
      image.src = url;
      await new Promise((resolve, reject) => {
        image.onload = resolve;
        image.onerror = () => reject(new Error('Photo illisible. Utilisez un fichier JPG, PNG ou WebP.'));
      });
      return {
        width: image.naturalWidth,
        height: image.naturalHeight,
        close: () => URL.revokeObjectURL(url),
        image
      };
    } catch (error) {
      URL.revokeObjectURL(url);
      throw error;
    }
  }

  async function preparePhoto(file, index) {
    const bitmap = await readPhoto(file);
    const source = bitmap.image || bitmap;
    if (bitmap.width * bitmap.height > 60000000) {
      bitmap.close();
      throw new Error('Une photo est trop grande. Exportez-la avec une résolution inférieure.');
    }
    const scale = Math.min(1, 2400 / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    const context = canvas.getContext('2d');
    context.fillStyle = '#fff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(source, 0, 0, canvas.width, canvas.height);
    bitmap.close();
    const blob = await new Promise((resolve, reject) => canvas.toBlob((result) => result ? resolve(result) : reject(new Error('Photo illisible.')), 'image/jpeg', 0.9));
    if (blob.size > 3 * 1024 * 1024) throw new Error('Photo trop lourde après préparation. Choisissez une image plus petite.');
    const prepared = new File([blob], `photo-${index + 1}.jpg`, {type: 'image/jpeg'});
    return {file: prepared, url: URL.createObjectURL(prepared)};
  }

  async function chooseFiles(fileList) {
    if (!fileList?.length) return;
    showError('');
    resetSavedState();
    const selected = [...fileList];
    if (selected.length + photos.length > photoCount) {
      showError(`Choisissez ${photoCount} photo${photoCount > 1 ? 's' : ''} au total. Supprimez une photo pour la remplacer.`);
      return;
    }
    for (const file of selected) {
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
        showError('Utilisez des fichiers JPG, PNG ou WebP de 10 Mo maximum. Sur iPhone, exportez les HEIC en JPEG.');
        return;
      }
    }
    setBusy(true);
    const prepared = [];
    try {
      for (const file of selected) prepared.push(await preparePhoto(file, photos.length + prepared.length));
      photos = [...photos, ...prepared];
      renderPhotos();
    } catch (error) {
      prepared.forEach((photo) => URL.revokeObjectURL(photo.url));
      showError(error instanceof Error ? error.message : 'Impossible de lire cette photo.');
    } finally {
      setBusy(false);
    }
  }

  function setConsent(nextConsent) {
    consent = nextConsent;
    consentButton.setAttribute('aria-checked', String(nextConsent));
    consentButton.dataset.state = nextConsent ? 'checked' : 'unchecked';
    consentButton.innerHTML = nextConsent ? '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>' : '';
  }

  async function restoreCartState() {
    try {
      const response = await fetch(cartJsonUrl, {credentials: 'same-origin', headers: {Accept: 'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      const existing = cart.items?.find((item) => String(item.variant_id) === variantId && Array.from({length: photoCount}, (_, index) => item.properties?.[`Photo ${index + 1}`]).every((url) => typeof url === 'string' && (url.startsWith('//cdn.shopify.com/') || url.startsWith('https://cdn.shopify.com/'))));
      if (existing?.key) {
        successText.textContent = `${photoCount === 1 ? 'La photo a' : `Les ${photoCount} photos ont`} déjà été reçue${photoCount > 1 ? 's' : ''} par Shopify et associée${photoCount > 1 ? 's' : ''} à ce projet dans votre panier. Passez commande pour confirmer votre achat.`;
        successBox.hidden = false;
        saveButton.hidden = true;
      }
    } catch (_) {}
  }

  async function saveProject(event) {
    event.preventDefault();
    showError('');
    if (photos.length !== photoCount) {
      showError(`Ajoutez ${photoCount === 1 ? 'la photo' : `les ${photoCount} photos`} avant d’enregistrer.`);
      return;
    }
    if (!consent) {
      showError('Merci de confirmer votre accord pour enregistrer ces photos.');
      return;
    }
    if (!variantId) {
      showError('La référence Shopify ne peut pas être chargée. Rechargez cet aperçu.');
      return;
    }
    setBusy(true);
    try {
      const data = new FormData();
      data.set('id', variantId);
      data.set('quantity', '1');
      data.set('properties[_Projet Click & Booth]', projectId);
      data.set('properties[Quelques mots à garder]', messageInput.value);
      data.set('properties[_E-mail du projet]', emailInput.value);
      data.set('properties[_Consentement photo]', 'oui');
      photos.forEach((photo, index) => data.set(`properties[Photo ${index + 1}]`, photo.file));
      const response = await fetch(addUrl, {method: 'POST', body: data, credentials: 'same-origin', headers: {Accept: 'application/json'}});
      const raw = await response.text();
      let result;
      try {
        result = JSON.parse(raw);
      } catch (_) {
        throw new Error('Shopify n’a pas confirmé l’enregistrement. Vos photos restent affichées ; aucune sauvegarde n’est confirmée.');
      }
      root.dataset.lastSaveStatus = String(response.status);
      root.dataset.lastSaveReason = result.description || '';
      if (!response.ok) throw new Error(`Shopify n’a pas confirmé l’enregistrement des photos. ${result.description || 'Le service de sauvegarde ne répond pas.'} Vos photos restent préparées dans ce navigateur.`);
      const received = Array.from({length: photoCount}, (_, index) => result.properties?.[`Photo ${index + 1}`]);
      if (!result.key || received.some((url) => !url || (!url.startsWith('//cdn.shopify.com/') && !url.startsWith('https://cdn.shopify.com/')))) {
        throw new Error(`Shopify n’a pas confirmé la réception de ${photoCount === 1 ? 'la photo' : `des ${photoCount} photos`}. Aucune sauvegarde complète n’est confirmée.`);
      }
      successText.textContent = `${photoCount === 1 ? 'La photo a' : `Les ${photoCount} photos ont`} été reçue${photoCount > 1 ? 's' : ''} par Shopify et associée${photoCount > 1 ? 's' : ''} à ce projet dans votre panier. Passez commande pour confirmer votre achat.`;
      successBox.hidden = false;
      saveButton.hidden = true;
    } catch (error) {
      showError(error instanceof Error ? error.message : 'Le service est indisponible. Vos photos restent affichées ; réessayez.');
    } finally {
      setBusy(false);
    }
  }

  fileInput.addEventListener('change', () => {
    void chooseFiles(fileInput.files);
    fileInput.value = '';
  });
  messageInput.addEventListener('input', () => {
    counter.textContent = `${messageInput.value.length}/80 caractères · demande à confirmer sur le modèle final`;
    previewMessage.textContent = messageInput.value || 'Votre histoire commence ici.';
    resetSavedState();
  });
  emailInput.addEventListener('input', resetSavedState);
  consentButton.addEventListener('click', () => setConsent(!consent));
  form.addEventListener('submit', saveProject);
  window.addEventListener('pagehide', () => photos.forEach((photo) => URL.revokeObjectURL(photo.url)), {once: true});

  renderPhotos();
  void restoreCartState();
})();
